var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteredicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-bg-red",
    transform: "translate(-1177 -305)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1177 305)",
    fill: "#f44336",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete_2_",
    "data-name": "delete (2)",
    transform: "translate(1187.004 313.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M222.843,154.7a.445.445,0,0,0-.445.445v8.41a.445.445,0,0,0,.89,0v-8.41A.445.445,0,0,0,222.843,154.7Zm0,0",
    transform: "translate(-212.505 -147.821)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M104.843,154.7a.445.445,0,0,0-.445.445v8.41a.445.445,0,0,0,.89,0v-8.41A.445.445,0,0,0,104.843,154.7Zm0,0",
    transform: "translate(-99.756 -147.821)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M1.26,5.655V16.618a2.455,2.455,0,0,0,.653,1.693A2.191,2.191,0,0,0,3.5,19h8.419a2.191,2.191,0,0,0,1.59-.687,2.455,2.455,0,0,0,.653-1.693V5.655a1.7,1.7,0,0,0-.436-3.343H11.45V1.756A1.748,1.748,0,0,0,9.688,0H5.737A1.748,1.748,0,0,0,3.975,1.756v.556H1.7A1.7,1.7,0,0,0,1.26,5.655ZM11.922,18.109H3.5A1.409,1.409,0,0,1,2.15,16.618V5.694H13.275V16.618a1.409,1.409,0,0,1-1.353,1.491ZM4.865,1.756A.857.857,0,0,1,5.737.888H9.688a.857.857,0,0,1,.872.868v.556h-5.7ZM1.7,3.2H13.728a.8.8,0,0,1,0,1.6H1.7a.8.8,0,0,1,0-1.6Zm0,0",
    transform: "translate(0 0)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M163.843,154.7a.445.445,0,0,0-.445.445v8.41a.445.445,0,1,0,.89,0v-8.41A.445.445,0,0,0,163.843,154.7Zm0,0",
    transform: "translate(-156.131 -147.821)",
    fill: "#f44336"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteredicon);
export default __webpack_public_path__ + "static/media/Deleteredicon.137a3ee598eaaac6c388a83add00b257.svg";
export { ForwardRef as ReactComponent };